/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createStoredFilter } from '../fn/stored-filters/create-stored-filter';
import { CreateStoredFilter$Params } from '../fn/stored-filters/create-stored-filter';
import { deleteStoredFilter } from '../fn/stored-filters/delete-stored-filter';
import { DeleteStoredFilter$Params } from '../fn/stored-filters/delete-stored-filter';
import { getStoredFilters } from '../fn/stored-filters/get-stored-filters';
import { GetStoredFilters$Params } from '../fn/stored-filters/get-stored-filters';
import { PageStoredFilterPageResponse } from '../models/page-stored-filter-page-response';
import { StoredFilterCreateResponse } from '../models/stored-filter-create-response';
import { updateStoredFilterPinning } from '../fn/stored-filters/update-stored-filter-pinning';
import { UpdateStoredFilterPinning$Params } from '../fn/stored-filters/update-stored-filter-pinning';


/**
 * Stored search filter endpoints. All operations require PRODUCT_ADMIN role.
 */
@Injectable({ providedIn: 'root' })
export class StoredFiltersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateStoredFilterPinning()` */
  static readonly UpdateStoredFilterPinningPath = '/filters/{filterId}/pin';

  /**
   * Pin the stored filter.
   *
   * Update pinning of the specified stored filter
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStoredFilterPinning()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateStoredFilterPinning$Response(params: UpdateStoredFilterPinning$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateStoredFilterPinning(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Pin the stored filter.
   *
   * Update pinning of the specified stored filter
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateStoredFilterPinning$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateStoredFilterPinning(params: UpdateStoredFilterPinning$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateStoredFilterPinning$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getStoredFilters()` */
  static readonly GetStoredFiltersPath = '/filters';

  /**
   * List the stored filters.
   *
   * List the stored filters to the owner merchant
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStoredFilters()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStoredFilters$Response(params: GetStoredFilters$Params, context?: HttpContext): Observable<StrictHttpResponse<PageStoredFilterPageResponse>> {
    const obs = getStoredFilters(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List the stored filters.
   *
   * List the stored filters to the owner merchant
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStoredFilters$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStoredFilters(params: GetStoredFilters$Params, context?: HttpContext): Observable<PageStoredFilterPageResponse> {
    const resp = this.getStoredFilters$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageStoredFilterPageResponse>): PageStoredFilterPageResponse => r.body)
    );
  }

  /** Path part for operation `createStoredFilter()` */
  static readonly CreateStoredFilterPath = '/filters';

  /**
   * Create stored filters.
   *
   * Create stored filters to the specified search interface
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createStoredFilter()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStoredFilter$Response(params: CreateStoredFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<StoredFilterCreateResponse>> {
    const obs = createStoredFilter(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create stored filters.
   *
   * Create stored filters to the specified search interface
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createStoredFilter$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStoredFilter(params: CreateStoredFilter$Params, context?: HttpContext): Observable<StoredFilterCreateResponse> {
    const resp = this.createStoredFilter$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StoredFilterCreateResponse>): StoredFilterCreateResponse => r.body)
    );
  }

  /** Path part for operation `deleteStoredFilter()` */
  static readonly DeleteStoredFilterPath = '/filters/{filterId}';

  /**
   * Delete stored filter.
   *
   * Delete specified stored filter.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteStoredFilter()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStoredFilter$Response(params: DeleteStoredFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteStoredFilter(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete stored filter.
   *
   * Delete specified stored filter.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteStoredFilter$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStoredFilter(params: DeleteStoredFilter$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteStoredFilter$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
